<template>
  <div
    v-if="item"
    :class="`card card-${model}`"
    :id="`card-${model}-${item.slug}`"
  >
    <div class="elr-card-inner">
      <CardHeader :url="url" :image="image" :model="model" :item="item" />
      <div class="elr-card-body">
        <div class="elr-card-content">
          <div class="card-item-header">
            <CardTitle :url="url">{{name}}</CardTitle>
            <CardDescription v-if="item.description">{{item.description}}</CardDescription>
          </div>
          <slot />
        </div>
      </div>
      <div v-if="url" class="elr-card-footer">
        <div class="elr-card-actions">
          <ButtonLink :url="url">{{buttonText}}</ButtonLink>
        </div>
        <div class="elr-card-actions" v-if="canUpdate(user)">
          <ButtonLink :url="`${url}/edit`">Edit</ButtonLink>
          <button
            v-if="canRemove(user)"
            :id="`button-delete-${model}-${item.slug}`"
            class="elr-button elr-button-danger"
            @click="remove"
          >Delete</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { canUpdate, canRemove, capitalize, showPrompt } from '../../utils/helpers';
import CardDescription from '../CardDescription/CardDescription';
import CardHeader from '../CardHeader/CardHeader';
import CardTitle from '../CardTitle/CardTitle';
import ButtonLink from '../ButtonLink/ButtonLink';

export default {
  name: 'Card',
  props: {
    buttonText: {
      type: String,
      default: 'See All',
    },
    item: {
      type: Object,
      required: true
    },
    model: {
      type: String,
      required: true
    },
    image: {
      type: String
    },
    url: {
      type: String,
    },
    user: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    ButtonLink,
    CardDescription,
    CardHeader,
    CardTitle
  },
  computed: {
    name() {
      return capitalize(this.item.name)
    }
  },
  methods: {
    canUpdate,
    canRemove,
    remove() {
      showPrompt();

      this.$emit('onRemoveItem');
    }
  }
};
</script>

<style scoped lang="scss">
@import '../../assets/sass/config';

.card {
  overflow: hidden;
  min-width: 300px;
  max-width: 363px;
  display: block;
  flex-basis: 0;
  flex-grow: 1;
  flex-shrink: 1;
  box-shadow: $shadow;
  background-color: #fff;
  margin: 10px;
  border-radius: 5px;

  .elr-card-inner {
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-between;
  }

  .elr-card-body {
    padding: 10px 20px;
    flex: 1;
  }

  .elr-card-footer {
    padding-left: 10px;
    padding-right: 10px;
    padding-bottom: 10px;
  }

  .elr-card-actions {
    display: flex;
    // flex-wrap: wrap;
    padding: 5px 10px;
  }

  .elr-card-actions .elr-button:nth-child(odd):not(:only-child) {
    margin-left: 0;
    margin-right: 10px;
  }

  .card-item-header {
    border-bottom: 1px solid $light-grey;
    margin-bottom: 10px;
  }

  .item-header {
    display: flex;
  }
}

.card-details-title {
  font-size: 18px;
  font-weight: 900;
  padding-top: 10px;
  margin-top: 0;
  padding-left: 5px;
  padding-bottom: 10px;
  border-top: 1px solid $light-grey;
  border-bottom: 1px solid $light-grey;
}
</style>

<style>
.elr-card-actions .elr-button {
  width: auto;
  flex: 1;
  flex-grow: 1;
  flex-shrink: 1;
  min-width: 0;
}
</style>
